import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
// Material imports
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField"; //Limitless import

import { withi18n } from "../../hocs/i18n";

var TestimonialScreen = function TestimonialScreen(_ref) {
  var classes = _ref.classes,
      t = _ref.t,
      message = _ref.message,
      onSubmitTestimonialHandle = _ref.onSubmitTestimonialHandle,
      onCancelDialog = _ref.onCancelDialog,
      containerClass = _ref.containerClass;
  var custTestimonial = message.custTestimonial;

  var _React$useState = React.useState({
    text: "",
    errorMessage: null,
    disableSubmit: custTestimonial ? false : true
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localState = _React$useState2[0],
      setLocalState = _React$useState2[1];

  var text = localState.text,
      errorMessage = localState.errorMessage,
      disableSubmit = localState.disableSubmit;
  React.useEffect(function () {
    if (custTestimonial) {
      setLocalState(_objectSpread({}, localState, {
        text: custTestimonial
      }));
    } else {
      setLocalState(_objectSpread({}, localState));
    }
  }, []);

  var handleTextChange = function handleTextChange(value) {
    var text = value.trim() === "" ? value.trim() : value;

    if (!text || text.length < 5 || text.length > 500) {
      setLocalState(_objectSpread({}, localState, {
        errorMessage: t("Please enter between 5 and 500 characters"),
        disableSubmit: true,
        text: text
      }));
    } else {
      setLocalState(_objectSpread({}, localState, {
        errorMessage: null,
        text: text,
        disableSubmit: false
      }));
    }
  };

  var onSubmit = function onSubmit() {
    setLocalState(_objectSpread({}, localState, {
      disableSubmit: true
    }));
    onSubmitTestimonialHandle(text);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.testimonialFieldContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    classes: {
      subtitle2: classes.heading
    },
    component: "div"
  }, t("Give a compliment or share feedback?")), /*#__PURE__*/React.createElement(TextField, {
    classes: {
      root: classes.textField
    },
    FormHelperTextProps: {
      classes: {
        contained: classes.helperContainer
      },
      component: "div"
    },
    InputProps: {
      classes: {
        multiline: classes.inputText
      }
    },
    error: errorMessage ? true : false,
    id: "testimonialTextarea",
    helperText: errorMessage || " ",
    variant: "outlined",
    value: text,
    multiline: true,
    rows: 3,
    onChange: function onChange(event) {
      return handleTextChange(event.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.submitButtonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    classes: {
      root: classes.submitButton
    },
    variant: "contained",
    onClick: text !== "" ? onSubmit : onCancelDialog,
    component: "div",
    color: "primary",
    disabled: text !== "" ? disableSubmit : false,
    id: "testimonialSubmitButton"
  }, text !== "" ? t("Send") : t("Cancel"))));
};

var styles = {
  heading: {
    margin: "8px 0",
    textAlign: "center"
  },
  textField: {
    width: 250
  },
  testimonialFieldContainer: {
    margin: 16
  },
  submitButtonContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 16,
    // flex: 1,
    alignItems: "flex-end"
  },
  submitButton: {
    width: 100
  },
  helperContainer: {
    margin: "8px 0"
  },
  inputText: {
    padding: "8px 8px"
  }
};
export default withStyles(styles)(withi18n(TestimonialScreen, "TestimonialScreen"));